import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface GuideJobPendingProps {
  status?: string;
}

const GuideJobPending: React.FC<GuideJobPendingProps> = memo(({ status = 'PENDING' }) => {
  const { t } = useTranslation('admin');

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="max-w-md w-full mx-auto p-8 text-center">
        {/* Pulsating Circle */}
        <div className="relative w-24 h-24 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full bg-blue-500 opacity-75 animate-ping"></div>
          <div className="absolute inset-0 rounded-full bg-blue-500 opacity-50 animate-pulse"></div>
          <div className="absolute inset-2 rounded-full bg-blue-600"></div>
        </div>

        {/* Status Text */}
        <h2 className="text-2xl font-semibold text-foreground mb-2">
          {t('guides.builder.jobPending.title')}
        </h2>
        <p className="text-muted-foreground mb-4">
          {t('guides.builder.jobPending.description')}
        </p>
        <p className="text-sm text-muted-foreground">
          {t('guides.builder.jobPending.status', { status })}
        </p>
      </div>
    </div>
  );
});

GuideJobPending.displayName = 'GuideJobPending';

export default GuideJobPending;

